export enum TermsAndConditionsPolicy {
  // Do not show terms & conditions
  None = 'none',
  // The customer needs to accept the terms & conditions to use the configurator.
  // The terms & conditions are shown on the location dialog, the customer also
  // needs to provide a valid ZIP code/state to use the configurator.
  Required = 'required',
  // Customer needs to accept the terms & conditions to save/quote a building
  RequiredForSaveQuote = 'required-for-save-quote',
}
